import React from 'react';
import { Grid, Typography } from '@mui/material';

import AddExternalTransferPharmacyButton from './components/AddExternalTransferPharmacyButton';
import ExternalPharmaciesTable from './components/ExternalPharmaciesTable';

const ExternalTransferPharmacy = () => {
  return (
    <>
      <Grid
        container
        sx={{ px: 3, py: 2 }}
        direction='row'
        justifyContent='space-between'
        alignItems='flex-end'
      >
        <Grid item sx={{ minHeight: 30, flexGrow: 1 }} alignItems='center'>
          <Typography variant='h6' sx={{ fontWeight: 600 }}>
            External Pharmacy Management
          </Typography>
        </Grid>
        <Grid item alignItems='center'>
          <AddExternalTransferPharmacyButton />
        </Grid>
      </Grid>

      <Grid item container sx={{ px: 3, py: 4 }}>
        <ExternalPharmaciesTable />
      </Grid>
    </>
  );
};

export default ExternalTransferPharmacy;
